<div class="card comments ml-4">
  <div *ngIf="user">
    <!-- comments -->
    <div *ngFor="let comment of comments" class="p-2 border-bottom">
      <borrower-activity-comment
        [comment]="comment" [user]="user" [activity]="activity"
      ></borrower-activity-comment>
    </div>

    <!-- add comment -->
    <div class="p-2">
      <borrower-activity-comment-form
        [user]="user" [activity]="activity" [autofocus]="!this.comments.length"
        (cancel)="onCancelAdd()"
      ></borrower-activity-comment-form>
    </div>
  </div>
</div>
